/** Canonical storage form for connections.email_address — always lowercase, trimmed. */
export function normalizeConnectionEmail(email: string): string {
  return email.trim().toLowerCase();
}
